import type { WiwState } from '@/store';

export const getUserMetadata = (state: WiwState) => state.data.metadata.user;
export const getUserMetadataLoaded = (state: WiwState) => state.data.metadata.userLoaded;
export const getUserMetadataLoading = (state: WiwState) => state.data.metadata.userLoading;
export const getAccountMetadata = (state: WiwState) => state.data.metadata.account;
export const getAccountMetadataLoaded = (state: WiwState) => state.data.metadata.accountLoaded;
export const getAccountMetadataLoading = (state: WiwState) => state.data.metadata.accountLoading;
